<div class="message">
    <div class="message-svg"></div>
    <p>{{ texto ?? 'Ops! não conseguimos encontrar nenhuma informação relacionada em nossos dados. Tente adicionar primeiro.' }}</p>
</div>
